import { render, staticRenderFns } from "./survey-dash.vue?vue&type=template&id=0f05aa66&scoped=true&"
import script from "./survey-dash.vue?vue&type=script&lang=js&"
export * from "./survey-dash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f05aa66",
  null
  
)

export default component.exports